import shoppingCartIcon from "@assets/icon-shopping-cart.svg";
import newsPostIcon from "@assets/logo-newspost.svg";
import cx from "classnames";

import styles from "@pages/Article/Article.module.scss";

type ArticlePurchaseLinkProps = {
  title: string;
  publishedDate: string;
};

export default function ArticlePurchaseLink({
  title,
  publishedDate,
}: ArticlePurchaseLinkProps): React.ReactElement {
  const date = encodeURIComponent(publishedDate);
  const encodedTitle = encodeURIComponent(title);

  return (
    <section
      className="mw-300px mx-auto my-4"
      data-testid="article-purchase-link-component"
    >
      <a
        className={cx(styles.textBtBlue, "flex items-center")}
        href={`https://newspost.newslink.sg/?publication=BT&date=${date}&title=${encodedTitle}`}
        target="_blank"
        rel="noreferrer"
      >
        <img src={newsPostIcon} width="58" height="44" alt="newspaper icon" />
        <span className={cx(styles.purchase)}>Purchase this article</span>
        <img
          src={shoppingCartIcon}
          alt="shopping cart icon"
          className="ml-1 ms-1 h-4 overflow-visible align-middle"
        />
      </a>
    </section>
  );
}
